/**
 * Swap the shell's icon for the brand's on a tenant page. The shell ships with
 * Flashroom's mark (index.html); once the page knows whose it is, the tab
 * shows that host's logo, or their crest when they have not uploaded one.
 */
import { brandIconHref } from "../../shared/brand-icon";

export function applyBrandIcon(brand: { logo_url: string | null; crest: string; accent: string }): void {
  if (typeof document === "undefined") return;
  const href = brandIconHref(brand);
  for (const rel of ["icon", "apple-touch-icon"]) {
    let link = document.head.querySelector<HTMLLinkElement>(`link[rel="${rel}"]`);
    if (!link) {
      link = document.createElement("link");
      link.rel = rel;
      document.head.appendChild(link);
    }
    if (rel === "icon") link.removeAttribute("type");
    link.href = href;
  }
}
